export default __webpack_public_path__ + "static/media/bg-image-nighttime.a9c730ff.jpg";